import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from './ability'
/* import { Can } from "@casl/vue";

Vue.component("Can", Can); */
Vue.use(abilitiesPlugin, ability)
